{
  "seat": {
    "nav": "工位",
    "title": "Kinio Station 工位",
    "subtitle": "只讀：資料來自 dev plane 的租約中心與各站回報。執行工具、租用 DUT 請用 kst。",
    "not_found": "找不到這個頁面",
    "plane_down": "連不上 dev plane（{{code}}），讀不到工位資料。要看某一站，在那台站上開本機工位頁 {{url}}。",
    "loading": "讀取中…",
    "view_stations": "依站",
    "view_resources": "依資源",
    "col_station": "站",
    "col_model": "機種",
    "col_version": "tools 版本",
    "col_online": "連線",
    "col_mode": "模式",
    "col_resources": "資源（忙 / 全部）",
    "col_running": "正在跑",
    "col_leases": "租約",
    "online": "在線",
    "offline": "離線",
    "last_seen": "最後上線 {{ago}} 前",
    "mode_seat": "工位模式",
    "mode_full": "完整",
    "prob_offline": "離線",
    "prob_duplicate": "資源 id 重複",
    "prob_tools_down": "tools 程式沒在跑",
    "running_item": "{{tool}}（{{caller}}，{{ago}}）",
    "lease_item": "{{name}}：{{holder}}（{{purpose}}，到 {{until}}）",
    "col_dut": "DUT",
    "col_type": "類型",
    "col_state": "狀態",
    "col_holder": "租用者",
    "col_purpose": "用途",
    "col_expires": "到期",
    "state_free": "空閒",
    "state_busy": "使用中",
    "state_offline": "離線",
    "dup_hint": "紅色的 DUT 有兩台以上的站回報：租約中心不會發它的租約，請改掉其中一台的登記。",
    "leases_err": "讀不到租約中心（{{code}}），租約欄改用各站回報的摘要（可能落後 30 秒）。",
    "empty": "—",
    "back": "← 全部工位",
    "detail_info": "站資訊",
    "hostname": "主機名稱",
    "lan": "區網位址",
    "modules": "模組",
    "ui_home": "本機首頁",
    "detail_resources": "資源",
    "detail_tools": "工具（只列，不執行）",
    "col_tool": "工具",
    "col_tier": "等級",
    "col_summary": "說明",
    "tools_err": "讀不到工具清單（{{code}}）",
    "detail_runs": "最近執行",
    "col_caller": "發起者",
    "col_started": "開始",
    "col_ended": "結束",
    "show_output": "看輸出",
    "hide_output": "收起",
    "output_empty": "（沒有輸出）",
    "output_truncated": "（只顯示前 256 KB）",
    "output_err": "讀不到輸出（{{code}}）",
    "runs_err": "讀不到最近執行（{{code}}）",
    "screenshot": "遠端截圖",
    "screenshot_busy": "截圖中…",
    "screenshot_err": "截圖失敗（{{code}}）",
    "screenshot_err_UI_NOT_RUNNING": "Station 的畫面沒開（nvr-ui 沒在跑），沒有畫面可截。",
    "kst_hint": "要操作這台：kst show {{name}}",
    "station_missing": "這台不在你看得到的工位裡。",
    "run_running": "執行中",
    "run_succeeded": "成功",
    "run_failed": "失敗",
    "run_cancelled": "已取消",
    "run_timeout": "逾時",
    "screenshot_err_SCREEN_TOO_LARGE": "畫面太大（超過 8 MB），不取回。"
  }
}
